<app-view-customer-workflow-stats-panel [contextIdDto]="contextIdDto" [customerId]="customerDto.customerId.id">
</app-view-customer-workflow-stats-panel>
